import { Injectable } from "@angular/core";
import { StorageService } from "../storage.service";

interface SelectedAddress {
  ad_id: number;
  ad_latitude: string;
  ad_longitude: string;
  ad_full_address: string;
  ad_reference?: string;
  ad_name?: string;
  created_at: string;
  updated_at: string;
}

interface DefaultAddress {
  latitude: number;
  longitude: number;
  timestamp: number;
  accuracy: number;
  isDefault?: boolean; // Opcional ya que no siempre está presente
}

@Injectable({
  providedIn: 'root'
})
export class AutomaticLocationService {

  constructor(private storageService: StorageService) {}

  private getParsedItem<T>(key: string): T | null {
    const item = this.storageService.getItem(key);
    
    // Si el StorageService ya devuelve un objeto parseado, lo retornamos directamente
    if (item && typeof item === 'object') {
      return item as T;
    }
    
    // Si es string, intentamos parsearlo
    if (typeof item === 'string') {
      try {
        return JSON.parse(item) as T;
      } catch {
        return null;
      }
    }
    
    return null;
  }

  getCurrentLocation(): DefaultAddress | null {
    return this.getParsedItem<DefaultAddress>('default_address');
  }

  getSelectAddress(): SelectedAddress | null {
    return this.getParsedItem<SelectedAddress>('selected_address');
  }

  giveSelectedAddress(): { latitude: number; longitude: number } | null {
    // Primero intenta obtener selected_address
    const selectedAddress = this.getSelectAddress();
    if (selectedAddress) {
      return {
        latitude: parseFloat(selectedAddress.ad_latitude),
        longitude: parseFloat(selectedAddress.ad_longitude)
      };
    }

    // Si selected_address es null, undefined o vacío, usa default_address
    const defaultAddress = this.getCurrentLocation();
    if (defaultAddress) {
      return {
        latitude: defaultAddress.latitude,
        longitude: defaultAddress.longitude
      };
    }

    // Si ninguno está disponible, retorna null
    return null;
  }
}
